angular.module('zc.projects')

.directive 'zcAdvertisingEditor', (ProjectAdvertising, Meta, BaseProjectCrudEditor) ->

  class AdvertisingEditor extends BaseProjectCrudEditor
    link: (scope, element, attrs) ->
      # only this specific functionality
      scope.matchTypes = {}
      Meta.getAdvertisingMatchTypes().then (res) ->
        scope.matchTypes = res

  editor = new AdvertisingEditor(
    ProjectAdvertising
    Meta
    '/templates/projects.settings/campaign/advertising_editor.html'
  )

  return editor.createDirective()



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/campaign/advertising_editor.directive.coffee